import {
    Chart,
    ChartCategoryAxis,
    ChartCategoryAxisItem,
    ChartLegend,
    ChartSeries,
    ChartSeriesItem,
    ChartSeriesItemTooltip,
    ChartSeriesLabels,
    ChartTitle,
    ChartTooltip
} from '@progress/kendo-react-charts';
import axios from 'axios';

import 'hammerjs';
import { AccessToken } from '../../config/AccessToken';
import { useLocalization } from '@progress/kendo-react-intl';
import { useEffect, useState } from 'react';
import { GridLayoutItem } from '@progress/kendo-react-layout';


export const ForkliftsChart = () => {

    const SERVER_URL = process.env.REACT_APP_SERVER_URL;

    const [vehiclesInactive, setVehiclesInactive] = useState(0);
    const [vehiclesFreeGoing, setVehiclesFreeGoing] = useState(0);
    const [vehiclesCarrying, setVehiclesCarrying] = useState(0);
    const [totalOperations, setTotalOperations] = useState(0);

    const [vehicleId, setVehicleId] = useState([]);
    const [vehiclesPerMissions, setVehiclesPerMissions] = useState([0]);

    const [error, setError] = useState('');

    const localizationService = useLocalization();

    const [instance, accessTokenRequest] = AccessToken();

    const operations: any = [
        {
            "kind": localizationService.toLanguageString('synchro.vehicles_inactive', 'NOT_FOUND'), "value": vehiclesInactive, "color": "#018CA5"
        },
        {
            "kind": localizationService.toLanguageString('synchro.vehicles_freeGoing', 'NOT_FOUND'), "value": vehiclesFreeGoing, "color": "#54A2B4"
        },
        {
            "kind": localizationService.toLanguageString('synchro.vehicles_carrying', 'NOT_FOUND'), "value": vehiclesCarrying, "color": "#74C3EE"
        },
    ];

    useEffect(() => {
        getForkliftsOperations();
        getVehiclesPerMissions();
    }, []);

    const getForkliftsOperations = async () => {
        let languageId = localStorage.getItem('languageId');

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            try {
                const res = await axios.get(`${SERVER_URL}/synchro/GetVehiclesPerOperations`, { headers })
                const data = res.data.data

                setVehiclesInactive(data.vehiclesInactive)
                setVehiclesFreeGoing(data.vehiclesFreeGoing)
                setVehiclesCarrying(data.vehiclesCarrying)
                setTotalOperations(data.vehiclesInactive + data.vehiclesFreeGoing + data.vehiclesCarrying)

            } catch (error: any) {
                setError(error);
            }
        }
        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken)
            })
        }
    }
    
    const getVehiclesPerMissions = async () => {
        let languageId = localStorage.getItem('languageId');

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            try {
                const res = await axios.get(`${SERVER_URL}/synchro/GetVehiclesPerMissions`, { headers })
                const data = res.data.data

                let vehicleId:any = [];
                let numberMissionsQueued:any = []
                data.forEach((item:any) => {
                    vehicleId.push(item.vehicleId);
                    numberMissionsQueued.push(item.numberMissionsQueued);
                });
                setVehicleId(vehicleId);
                setVehiclesPerMissions(numberMissionsQueued);

            } catch (error: any) {
                setError(error);
            }
        }
        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken)
            })
        }
    }

    const categories = vehicleId;

    const series: any = [
        {
            name: localizationService.toLanguageString('synchro.number_missions_queued_per_vehicle', 'NOT_FOUND'), 
            data: [vehiclesPerMissions], 
            "color": "#018CA5"
        }        
    ];

    return (
        <>
            <Chart>
                <ChartTitle color='#838393' text={`${localizationService.toLanguageString('synchro.vehicle_operations', 'NOT_FOUND')} (${localizationService.toLanguageString('synchro.operations', 'NOT_FOUND')} ${totalOperations}) `} />
                <ChartSeries>
                    <ChartSeriesItem type="donut" data={operations} categoryField="kind" field="value" color={operations.color}>
                        {/*<ChartSeriesLabels color="#fff" background="none" content={labelContent} />*/}
                    </ChartSeriesItem>
                </ChartSeries>
                <ChartLegend position="bottom" reverse={false} labels={{ color: "#018CA5" }} />
            </Chart>
            <div style={{ textAlign: 'center', borderTop: '1px solid #ededed' }}>
                <div className="k-text-inverse k-text-uppercase k-font-weight-bold" style={{ marginTop: '20px' }}>
                    <p style={{ color: '#34A3B7' }}>{localizationService.toLanguageString('synchro.missions_queued_per_vehicle', 'NOT_FOUND')}</p>
                </div>     

                <Chart>
                    <ChartTooltip format="{0}" />
                    <ChartCategoryAxis>
                        <ChartCategoryAxisItem categories={categories} startAngle={45} />
                    </ChartCategoryAxis>
                    <p style={{ fontSize:'13px', color:'#838393'}}>
                        {localizationService.toLanguageString('synchro.number_missions_queued_per_vehicle', 'NOT_FOUND')}
                    </p>
                    <ChartSeries>
                        {series.map((item:any, idx:any) => (
                            <ChartSeriesItem key={idx} type="column" data={item.data} name={item.name} color={item.color}>
                                <ChartSeriesItemTooltip background="#34A3B7" format="{0}" />
                            </ChartSeriesItem>
                        ))}
                    </ChartSeries>
                    <ChartLegend 
                        position="top" 
                        orientation="horizontal" 
                        labels={{ color: "#018CA5" }} 
                    />
                </Chart>

            </div>
        </>
    )
}